import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "./langs";
import router from '@/router'; // 引入路由实例
Vue.use(VueI18n);
const DEFAULT_LANG = "zh-CN";
//从localStorage获取语言选择。
const i18n = new VueI18n({
    // console.log(navigator.language);
    locale: DEFAULT_LANG, //初始未选择默认 cn 中文, zh-Cn 简体中文, zh-SG 新加坡中文,由于中文多样化,匹配zh
    messages,
    silentTranslationWarn: true,
});
export const setLanguage = (lang) => {
    if (lang == undefined) {
        console.log(router,router.history.current);
        if(router.currentRoute.query.language){
            lang = router.currentRoute.query.language;
        }
        //如果localStorage 没有存储,获取浏览器语言
        if (lang == null) {
            lang = window.localStorage.getItem("h5Language")?window.localStorage.getItem("h5Language"):DEFAULT_LANG; //获取浏览器语言
            //判断是否是英语,校验是否包含en
            if (lang.indexOf("en") > -1) {
                lang = "en-US";
            }

            if (messages[lang] === undefined) {
                //如果浏览器语言不在语言包中,默认展示中文
                lang = DEFAULT_LANG;
            }
        }
    }
    console.log(lang);
    window.localStorage.setItem("h5Language", lang);
    i18n.locale = lang;
};
setTimeout(()=>{
    setLanguage();
},100)

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/i18n.js